/**=========================================================
 * Module: app-field.js
 * Handles field
 =========================================================*/

App.directive('appField', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/field.html',
      restrict: 'E',
      replace: true,
      controller: 'FieldController',
      link: function($scope, element, attrs){
        if($scope.field.tooltip && $scope.field.tooltip.attachTo){

          var setCloseTooltipEvents = function(){
            setTimeout(function(){
              /*$(element).find('input, textarea').on('focus', function(){
                $('.close-tooltip-button', element).click();
              });*/
              $(element).find('input, textarea').on('input', function(){
                $('.hidden-close-tooltip-button', element).click();
              });
              $(element).find('input[type=submit]').on('click', function(){
                $('.hidden-close-tooltip-button', element).click();
              });
              $(element).find('select').on('change', function(){
                $('.hidden-close-tooltip-button', element).click();
              });
            }, 500);
          }
          

          var positionTooltip = function() {
              // Wait for templates to render
              $scope.$evalAsync(function() {
                if($($scope.field.tooltip.attachTo).length){
                  var top = 0;
                  var left = 0;
                  var baseLeft = $('.field-tooltip', element).parent().offset().left;
                  var baseTop = $('.field-tooltip', element).parent().offset().top;
                  var elementFromBaseLeft = $($scope.field.tooltip.attachTo).offset().left - baseLeft;
                  var elementFromBaseTop = $($scope.field.tooltip.attachTo).offset().top - baseTop;
                  var elementWidth = $($scope.field.tooltip.attachTo).outerWidth();
                  var elementHeight = $($scope.field.tooltip.attachTo).outerHeight();
                  var tooltipWidth = 200;//$('.tooltip', element).outerWidth();
                  var tooltipHeight = $('.tooltip', element).outerHeight() || 80;
                  var windowWidth = $(window).width();
                  var p = 10;

                  if($scope.field.tooltip.position.indexOf('bottom')>=0){
                    top = p + elementFromBaseTop + elementHeight;
                    left = left || (p + elementFromBaseLeft);
                  }
                  if($scope.field.tooltip.position.indexOf('right')>=0){
                    top = top || p;
                    left = p + elementFromBaseLeft + elementWidth;
                  }
                  if($scope.field.tooltip.position.indexOf('left')>=0){
                    top = top || p;
                    left = elementFromBaseLeft - tooltipWidth;
                  }
                  if($scope.field.tooltip.position.indexOf('top')>=0){
                    top = elementFromBaseTop - tooltipHeight;
                    left = left || (p + elementFromBaseLeft);
                  }
                  if($scope.field.tooltip.arrowPosition=='bottom' && $scope.field.tooltip.position=='right'){
                    top = elementFromBaseTop - tooltipHeight + p*2;
                  }
                  if($scope.field.tooltip.arrowPosition=='top' && $scope.field.tooltip.position=='right'){
                    top = p;
                  }
                  if(left + baseLeft + tooltipWidth > windowWidth){
                    left = windowWidth - tooltipWidth - baseLeft;
                  }
                  if(left < tooltipWidth/2){
                    left = tooltipWidth / 2;
                  }
                  $('.field-tooltip', element)
                      .css('top', top + 'px')
                      .css('left',left + 'px');
                }
              });
          };
          // Trigger when number of children changes,
          // including by directives like ng-repeat
          var watch = $scope.$watch(function() {
            return element.children().length;
          }, function(){
            positionTooltip();
            setCloseTooltipEvents();
          });
          

          $scope.$on('$recalculateTooltipPosition', positionTooltip);
        }
      }
  };

});
